import { useEffect, useState } from 'react';
import { getAccessToken, getUser } from '../../stores/auth/services';
import ConfirmModal from '../SharedComponents/ConfirmModal/ConfirmModal';

const noTherapistText =
  'Ihr Tablet ist noch nicht mit einem Therapeut:innen–Account verbunden. Bitte geben Sie diesen Code an Ihre:n Therapeut:in.';

const noSetsText =
  'Ihr:e Therapeut:in hat noch kein Übungsset für Sie ausgewählt';

export function TherapistNoticeModal({
  noTherapistNotice,
  syncPatientSettings,
  setNoTherapistNotice,
  serverLogoutUser,
  localLogoutUser,
}) {
  const [code, setCode] = useState('');

  const isNoSets = noTherapistNotice.includes('Übungsset');

  useEffect(() => {
    (async () => {
      if (isNoSets) return;
      const user = await getUser();
      setCode(user.code);
    })();
  }, [isNoSets]);

  return (
    <ConfirmModal
      headerText={'Download fehlgeschlagen'}
      contentText={isNoSets ? noSetsText : noTherapistText}
      hasEmail={!isNoSets}
      emailText={code}
      isVisible={Boolean(noTherapistNotice)}
      confirmText={'wiederholen'}
      confirmAction={async () => {
        await syncPatientSettings();
      }}
      cancelText={'abmelden'}
      cancelAction={async () => {
        setNoTherapistNotice(false);
        await serverLogoutUser({ jwt: await getAccessToken() });
        await localLogoutUser();
      }}
      emailCanBeCopied={!isNoSets}
    />
  );
}
